module.exports = __webpack_public_path__ + "static/media/hr icon 3.a9bc543b.png";